import { Text } from '@mantine/core';

interface ISectionTitle {
  title: string;
}

const SectionTitle = ({ title }: ISectionTitle) => {
  return (
    <Text style={{ fontSize: 20, fontWeight: 'bold' }} c='#378F0E' mb={20} mt={40}>{title}</Text>
  )
}

export default SectionTitle;